// Iter-276.G (Top-20 #20) — ReviewedBadge extracted from
// PartnerRateTable.jsx as part of the LoC refactor. Per-row editorial
// review timestamp badge ("Reviewed today" / "Reviewed Xd ago") that
// surfaces the recency signal next to the lender name.

import React from "react";
import { formatReviewedAgo } from "./formatHelpers";

export default function ReviewedBadge({ iso, slug }) {
  const label = formatReviewedAgo(iso);
  if (!label) return null;
  return (
    <span
      data-testid={`rate-reviewed-${slug}`}
      className="mt-1 inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-[0.12em] text-slate-500"
      title={`Last editorial review: ${new Date(iso).toLocaleDateString()}`}
    >
      <span
        aria-hidden
        className="inline-block w-1 h-1 rounded-full bg-[#10B981]"
      />
      {label}
    </span>
  );
}
